.sn-workflow-setup {
  display: flex;
  flex-direction: column;
  gap: map-get($spacings, 2xl);

  @include above($breakpoint-desktop-md) {
    gap: map-get($spacings, 3xl);
  }

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($spacings, 2xl);

    @include above($breakpoint-desktop-md) {
      margin-bottom: map-get($spacings, 3xl);
    }

    .me-text {
      max-width: 824px;
    }
  }

  &__table-wrapper {
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: 1px solid var(--border-color-secondary);
    border-radius: var(--radius-size-lg);
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    @include above($breakpoint-desktop) {
      min-width: 500px;
    }
  }

  &__row {
    &--header {
      background-color: var(--background-color-secondary);
    }
  }

  &__cell {
    width: 50%;
    padding: map-get($spacings, md);
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    text-align: left;
    vertical-align: middle;
    border: 1px solid var(--border-color-secondary);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
      font-size: map-get($font-sizes, xl);
    }

    &--header {
      font-weight: 700;
      font-size: map-get($font-sizes, md);
      color: rgb(20 18 18 / 60%); // TODO: no exact token

      @include above($breakpoint-desktop) {
        font-size: map-get($font-sizes, xl);
      }
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
